import { action, observable } from "mobx";
import WebinarRegistrationField from '../WebinarRegistrationField';
import WebinarRegistrationEmailFieldSettings from './WebinarRegistrationEmailFieldSettings';

export default class WebinarRegistrationEmailField extends WebinarRegistrationField {
    constructor(settings?: Partial<WebinarRegistrationEmailField>) {
        super();
        if (settings) this.update(settings);
    }

    @observable settings: WebinarRegistrationEmailFieldSettings;

    @action update(settings: Partial<WebinarRegistrationEmailField>) {
        super.update(settings);
    }

    get hasSettings() {
        return true;
    }

    hasChanged(field: WebinarRegistrationEmailField) {
        return super.hasChanged(field) || this.settings.hasChanged(field.settings);
    }

    copy() {
        return new WebinarRegistrationEmailField({
            ...this,
            settings: this.settings?.copy(),
        });
    }

    static fromJson(json: any) {
        return new WebinarRegistrationEmailField({
            ...json,
            settings: json.settings ? WebinarRegistrationEmailFieldSettings.fromJson(json.settings) : undefined
        });
    }
}